import React, { useState, useEffect } from "react";
import { Box, Container, useMediaQuery } from "@mui/material";
import UserInfo from "./UserInfo";
import InstructionContent from "./InstructionContent";
import useInstructionStyle from "../../instructionStyle/default/instructionDefaultStyle";
import { decryptData } from "../../../../crypto";
import { useProfile } from "../../../../context/ProfileContext";
import { useQuestion } from "../../../../context/QuestionsContext";
import { toast } from "react-toastify";
import SubmissionPopupReLogin from "../../../../components/popups/SubmissionPopupReLogin";
import { useQuestionSection } from "../../../../hooks/iit/useQuestionSection";
import { fetchCurrentTimeApi } from "../../../../services/service"

function InstructionDefault() {
  const [showSidebar, setShowSidebar] = useState(false);
  // isDesktop: ≥900px — sidebar always visible, no hamburger
  // <900px (tablet + mobile) — hamburger shown, sidebar is an overlay drawer
  const isDesktop = useMediaQuery("(min-width:900px)");
  const classes = useInstructionStyle();

  const { profile } = useProfile();
  const { question } = useQuestion();

  const examName = decryptData(sessionStorage.getItem("exam_name")) || "";

  // User info
  const user = {
    examName: examName || "",
    duration: question?.duration || "",
    candidateName: profile?.full_name || "",
    mobile: profile?.phone || "",
    rollNumber: profile?.learner_information?.roll_number || null,
    image: profile?.image_url || "N/A",
  };

  const toggleSidebar = () => {
    setShowSidebar((prev) => !prev);
  };

  useEffect(() => {
    const examTime = new Date(sessionStorage.getItem("startDateTime"));

    //exam start toast
 if (examTime && !isNaN(examTime.getTime())) {
      let intervalId;
      let wasLiveOnMount = false;

      // First check immediately on mount/reload
      const initialCheck = async () => {
        try {
          const response = await fetchCurrentTimeApi().catch(() => null);
          if (response && response.data && response.data.currentTime) {
            const rawCurrentTime = response.data.currentTime;
            const formattedCurrentTime = new Date(
              typeof rawCurrentTime === "string" ? rawCurrentTime.replace(" ", "T") : rawCurrentTime
            );
            if (formattedCurrentTime >= examTime) {
              wasLiveOnMount = true;
            }
          }
        } catch (e) {
          console.error("Error doing initial live check:", e);
        }
      };

      // Periodic check every 10 seconds
      const checkTime = async () => {
        try {
          const response = await fetchCurrentTimeApi();
          if (response && response.data && response.data.currentTime) {
            const rawCurrentTime = response.data.currentTime;
            const formattedCurrentTime = new Date(
              typeof rawCurrentTime === "string" ? rawCurrentTime.replace(" ", "T") : rawCurrentTime
            );
            if (formattedCurrentTime >= examTime) {
              if (!wasLiveOnMount) {
                toast.success("The exam is now live. You can start!", {
                  toastId: "examTime",
                });
              }
              if (intervalId) clearInterval(intervalId);
            }
          }
        } catch (error) {
          console.error("Error checking live time:", error);
        }
      };

      const runTimer = async () => {
        await initialCheck();
        if (!wasLiveOnMount) {
          intervalId = setInterval(checkTime, 10000); // 10 seconds
        }
      };

      runTimer();

      return () => {
        if (intervalId) clearInterval(intervalId);
      };
    }
  }, []);

  const { showSubmissionPopupReLogin, countdownByHead } = useQuestionSection({});

  return (
    <Box disableGutters className={classes.appContainer}>
      <Box display="flex" flexDirection={{ xs: "column", md: "row" }}>
        {!isDesktop && showSidebar && (
          <Box className={classes.backdrop} onClick={toggleSidebar} />
        )}
        {/* Sidebar is position:fixed, so it overlays content on mobile */}
        <UserInfo user={user} isOpen={isDesktop ? true : showSidebar} />
        <Box
          flex={1}
          sx={{
            // ≥900px: sidebar is fixed at 18%, push content right
            // <900px: sidebar is an overlay drawer, content stays full width
            width: { md: '82%', xs: '100%' },
            marginLeft: { md: '18%', xs: 0 },
            transition: 'all 300ms ease-in-out'
          }}
        >
          <InstructionContent toggleSidebar={toggleSidebar} />
        </Box>
      </Box>
      <SubmissionPopupReLogin
        open={showSubmissionPopupReLogin}
        countdown={countdownByHead}
      />
    </Box>
  );
}

export default InstructionDefault;